import { PropsWithChildren } from "react";
import {
  imageCaption,
  imageCaptionVariant,
  imageContainer,
  imageOverlay,
} from "./styles.css";

type HeroImageProps = {
  caption?: string;
  captionType?: "default" | "dark";
  withOverlay?: boolean;
};

export const HeroImageWrapper = ({
  caption,
  children,
  withOverlay,
  captionType = "default",
}: PropsWithChildren<HeroImageProps>) => {
  return (
    <div className={imageContainer}>
      {withOverlay && <div className={imageOverlay} />}
      {children}
      {caption && <p className={imageCaptionVariant[captionType]}>{caption}</p>}
    </div>
  );
};
